<!-- 日告警数量 -->
<template>
	<div>
		<dv-border-box-12 class="padding-lr-sm padding-bottom-lg margin-top-xs dayTimeBox">
			<SecondTitle :secTitle="secTitle" class="margin-bottom-xs"></SecondTitle>
			<Chart :cdata="cdata" :width="'500'" :height="'190'" />
		</dv-border-box-12>
	</div>
</template>

<script>
import SecondTitle from '../secondTitle.vue';
import Chart from '../echart/chart.vue'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
		secTitle:{
		  title:'日告警数量'
		},
		cdata: {
		  category: [
		    "08/01",
		    "08/02",
		    "08/03",
		    "08/04",
		    "08/05",
		    "08/06",
		  ],
		  rateData: [],
		  id:"carAddChart",
		  legendData:[{
		        name:"上月",
		        icon: 'roundRect',
			},
			{
			    name:"本月",
			    icon: 'roundRect',
			},
		  ],
		  series:[
		      {
		        name: "上月",
		        type: "line",
		        smooth: true,
		
		        symbolSize: 1,
		        // yAxisIndex: 1,
		        itemStyle: {
		          color: "rgba(95, 189, 255, 1)" 
		        },
		        data: [0, 0, 0, 0, 0, 0,0, 0, 0, 0]
		      },
			  {
			    name: "本月",
			    type: "line",
			    smooth: true,
			  		
			    symbolSize: 1,
			    // yAxisIndex: 1,
			    itemStyle: {
			      color: "rgba(255, 90, 134, 1)" 
			    },
			    data: [0, 0, 0, 0, 0, 0,0, 0, 0, 0]
			  },
		  ],
		  yAxisname:"(次)"
		}
    };
  },
  components: {
	  SecondTitle,
	  Chart
  },
  mounted () {
    
  },
  methods: {
    getData(data){
      this.selectDailyAlarm(data);
    },
    selectDailyAlarm(data={}){
      let _this = this;
      let params = {};
      if(data){
				params = {
					"enCode":"TiDB-shengshiqu-rigaojingshuliang",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-rigaojingshuliang"//TiDB-全国-日告警数量
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
		  		console.log("日告警数量",res)
          let last_alarmNum=[];
          let cur_alarmNum=[];
          let xList=[];
          res.map(item=>{
            last_alarmNum.push(item.last_alarmNum);
            cur_alarmNum.push(item.cur_alarmNum);
            xList.push(item.cur_date);
          })
          this.cdata.category = xList;//
          this.cdata.series[0].data = last_alarmNum;
          this.cdata.series[1].data = cur_alarmNum;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
	.dayTimeBox{
		width: 500px;
		height: 240px;
	}
</style>